import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Boolean Yes/No Cell Renderer
 *
 * Renders "SI" for truthy values and "NO" for falsy values
 * Center-aligned with small text styling
 *
 * @example
 * ```typescript
 * {
 *   field: 'wasTheVisitOnSite',
 *   headerName: 'En Sitio',
 *   cellRenderer: BooleanYesNoCellRendererComponent,
 *   minWidth: 100
 * }
 * ```
 */
@Component({
  selector: 'app-boolean-yesno-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-center text-sm">
      {{ params.value ? 'SI' : 'NO' }}
    </div>
  `,
})
export class BooleanYesNoCellRendererComponent implements CellRenderer<any, boolean> {
  @Input() params!: CellRendererParams<any, boolean>;
}
